import { render } from "./MiSuscripcion.vue?vue&type=template&id=d03080a0"
import script from "./MiSuscripcion.vue?vue&type=script&lang=js"
export * from "./MiSuscripcion.vue?vue&type=script&lang=js"
script.render = render

export default script